import { getCookie } from "@repo/client-cookies";

declare global {
  interface Window {
    OneTrust?: {
      OnConsentChanged: (handler: () => void) => void;
    };
  }
}

export const setupConsentBannerClosedListener = (
  onBannerClosed: () => void,
): (() => void) => {
  const consentCookie = getCookie("OptanonAlertBoxClosed");

  if (consentCookie) {
    onBannerClosed();
    return () => {};
  }

  let hasTriggered = false;

  const consentChangedHandler = () => {
    if (hasTriggered) return;

    const cookie = getCookie("OptanonAlertBoxClosed");

    if (cookie) {
      hasTriggered = true;
      onBannerClosed();
    }
  };

  const setupListener = () => {
    window.OneTrust?.OnConsentChanged(consentChangedHandler);
  };

  if (!window.OneTrust) {
    window.addEventListener("OneTrustReady", setupListener);

    return () => {
      window.removeEventListener("OneTrustReady", setupListener);
    };
  } else {
    setupListener();
    return () => {};
  }
};
